import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getGroupTreeContributions } from '../../../services/groupsService'
import { deepCopy } from '../../../util/Utils'
import useNotifications from '../../../hooks/useNotifications'

export default function useTreeChanges({ treeContributionsData, setTreeContributionsData, treeId, filtersState }) {
  const { error } = useNotifications()
  const { t } = useTranslation()
  const fetchMoreTreeContributions = useCallback(async () => {
    if (treeContributionsData?.tfUserContributions.nextPageToken) {
      try {
        const treeContributionsResponse = await getGroupTreeContributions(
          treeId,
          filtersState.currentFilters.type,
          filtersState.currentFilters.subtypes.map((value) => value.value),
          treeContributionsData.tfUserContributions.nextPageToken
        )
        setTreeContributionsData((prevState) => {
          const prevStateCopy = deepCopy(prevState)
          prevStateCopy.tfUserContributions.contributions = prevStateCopy.tfUserContributions.contributions.concat(
            treeContributionsResponse.data.tfUserContributions.contributions
          )
          prevStateCopy.tfUserContributions.persons = prevStateCopy.tfUserContributions.persons.concat(
            treeContributionsResponse.data.tfUserContributions.persons
          )
          prevStateCopy.tfUserContributions.nextPageToken =
            treeContributionsResponse.data.tfUserContributions.nextPageToken
          prevStateCopy.tfUserContributions.contributorId =
            treeContributionsResponse.data.tfUserContributions.contributorId
          return prevStateCopy
        })
        return true
      } catch (err) {
        error(t('tree-contributions.errorFetchingData', `Error getting  tree contributions data`), err)
      }
    }
    return false
  }, [
    treeContributionsData?.tfUserContributions.nextPageToken,
    treeId,
    filtersState.currentFilters.type,
    filtersState.currentFilters.subtypes,
    setTreeContributionsData,
    error,
    t,
  ])

  useEffect(() => {
    const fetchTreeContributions = async () => {
      try {
        const treeContributionsResponse = await getGroupTreeContributions(treeId)
        setTreeContributionsData(treeContributionsResponse.data)
      } catch (err) {
        error(t('tree-contributions.errorFetchingData', `Error getting  tree contributions data`), err)
      }
    }
    fetchTreeContributions()
  }, [treeId, error, setTreeContributionsData, t])

  return { fetchMoreTreeContributions }
}
